import { DialogDescription } from "@radix-ui/react-dialog";
import { submitRepostContent } from "api-function/postContentApi";
import { profileVerified } from "assets";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "components/app/dialog/dialog";
import ImageUrlProfile from "components/app/image-url/ImageUrlProfile";

import { Avatar, AvatarFallback } from "components/ui/avatar";
import { Button } from "components/ui/button";
import CopyLinkButton from "pages/profile-post-contents-page-view/post-component/CopyLinkButton";
import { useEffect, useRef, useState } from "react";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, StatusMsg } from "utils";

import { Service } from "utils/services";

import { Popover, PopoverContent, PopoverTrigger } from "@radix-ui/react-popover";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFaceSmileBeam } from "@fortawesome/free-solid-svg-icons";
import EmojiPicker, { EmojiClickData, EmojiStyle } from "emoji-picker-react";

import { AppLog } from "services";

import useNewFeedDialogShareStore from "store/dialog/useNewFeedDialogShare";

import { Loader, Search, X } from "lucide-react";
import ImageUrlProfileStory from "components/app/image-url/ImageUrlProfileStory";
import { Textarea } from "components/ui/textarea";
import { SelectSeparator } from "components/ui/select";
import DailogSearchFriendsSend from "./DailogSearchFriendsSend";
import { ShimmerFriends } from "components/app/shrimmer/Shrimmer";
import { useDispatch } from "react-redux";
import { setInitFriends } from "store/newFeedSlice";
interface DialogProps {
  post: any;
  onSuccess: (value: any) => void;
  isDialogOpen: boolean;
  setIsDialogOpen: (value: boolean) => void;
}
export default function NewFeedDailogShare({ post, onSuccess, isDialogOpen, setIsDialogOpen }: DialogProps) {
  // * === Variable === * //

  const { friends, friendAppRecord, initializePage, disposePage, fetchFriends } = useNewFeedDialogShareStore();

  // * === Functions === * //

  // * === useEffect === * //

  useEffect(() => {
    const loadInitialDialogShare = async () => {
      try {
        initializePage();
      } catch (error) {
        AppLog.show({
          message: `[loadInitialReactions]`,
          status: StatusMsg.error,
          error,
        });
      }
    };

    if (isDialogOpen) {
      loadInitialDialogShare();
    } else {
      disposePage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDialogOpen]);
  const [textComment, setTextComment] = useState("");
  const onEmojiClick = (emojiData: EmojiClickData) => {
    setTextComment((prev) => prev + emojiData.emoji);
    // setShowEmojiPicker(false);
  };
  const onHandleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (textComment) {
        setTextComment("");
      }
    }
  };
  // ------------submit send ----------

  const [textInput, setTextInput] = useState<string>("");

  const submitSharePost = async () => {
    const result = await submitRepostContent({
      providerPostId: post?.provider_post_id.toString(),
      medaiTitle: textInput,
    });
    if (result.status === "success") {
      const tmpPost = { ...post };
      if (tmpPost && tmpPost.post_attachments) {
        tmpPost.reaction_share_count = (Number(tmpPost.reaction_share_count) || 0) + 1;
        onSuccess(tmpPost);
      }

      setIsDialogOpen(false);
    } else {
    }
  };
  const shareOptions = [
    {
      name: "Facebook",
      icon: <i className="fa-brands fa-facebook"></i>,

      link: `https://www.facebook.com/sharer/sharer.php?u=https://flipflop.maxx4business.com/post/${post?.provider_post_id}`,
    },
    {
      name: "Messenger",
      icon: <i className="fa-brands fa-facebook-messenger"></i>,
      link: `https://flipflop.maxx4business.com/post/${post?.provider_post_id}`,
    },
    {
      name: "Telegram",
      icon: <i className="fa-brands fa-telegram"></i>,
      link: `https://t.me/share/url?url=https://flipflop.maxx4business.com/post/${post?.provider_post_id}`,
    },

    // {
    //   name: "WhatsApp",
    //   icon: <i className="fa-brands fa-whatsapp"></i>,
    //   link: `https://wa.me/?text=https://flipflop.maxx4business.com/post/${post?.provider_post_id}`,
    // },
    {
      name: "Copy Link",
      icon: <CopyLinkButton endPoint={`post/${post?.provider_post_id}`} />,
    },
  ];

  const [isDailogSearchFriendsSend, setIsDailogSearchFriendsSend] = useState<boolean>(false);
  const { token } = useAppSelector((state) => state.auth);
  const [loadingButtonIndex, setLoadingButtonIndex] = useState<number | null>(null);
  const [clickedButtons, setClickedButtons] = useState<number[]>([]); // Track clicked buttons

  const submitSendMessage = async (index: number) => {
    if (clickedButtons.includes(index)) return; // Prevent re-clicking

    setLoadingButtonIndex(index);
    try {
      const url = `${RouteApi.submitSendMessage}token=${token}`;
      const data = {
        chat_room_id: null,
        receiver_id: initFriends[0]?.id,
        message_type: "Send Attachment",
        message_text: "",
        message_src: post.post_attachments[0].attachment_source,
        message_url: post.post_attachments[0].attachment_media_image_file_src,
        provider_storage_host_id: post.provider_storage_host_id,
        account_id: post.account_id,
        post_id: post.provider_post_id,
        attachment_id: post.post_attachments[0].attachment_id,
        order_id: "",
        message_length: 0,
        provider_attachment_type: post?.media_type,
        message_thumbnail_url: post.post_attachments[0].attachment_thumbnail_image_file_src,
      };

      const response = await RequestApi(url, { data });

      if (response.status === "success") {
        setLoadingButtonIndex(null);
        setClickedButtons((prev) => [...prev, index]); // Mark button as clicked
        setIsDailogSearchFriendsSend(false);
      }
    } catch (error) {
      AppLog.show({
        message: `[submitSendMessage]`,
        status: StatusMsg.error,
        error,
      });

      setLoadingButtonIndex(null);
    }
  };

  // -------------------------
  const containerRef = useRef<HTMLDivElement>(null);

  const [hovered, setHovered] = useState(false);
  const [showPrev, setShowPrev] = useState(false);

  const handleScroll = () => {
    const container = containerRef.current;
    if (container) {
      const atStart = container.scrollLeft === 0;
      setShowPrev(!atStart);

      const atEnd = container.scrollWidth - container.scrollLeft <= container.clientWidth + 1;
    }
  };

  useEffect(() => {
    const loadInitialStory = async () => {
      try {
        initializePage();
      } catch (error) {
        AppLog.show({
          message: `[loadInitialStory]`,
          status: StatusMsg.error,
          error,
        });
      }
    };

    loadInitialStory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const container = containerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (container) container.removeEventListener("scroll", handleScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const scroll = (direction: "left" | "right") => {
    const container = containerRef.current;
    if (container) {
      const scrollAmount = direction === "left" ? -container.clientWidth : container.clientWidth;
      container.scrollBy({ left: scrollAmount, behavior: "smooth" });

      setTimeout(() => handleScroll(), 300);
    }
  };

  // ------------------

  // const [initFriends, setInitFriends] = useState<any>();
  const [LoadinginitFriends, setLoadingInitFriends] = useState<any>();
  const dispatch = useDispatch();
  const { initFriends } = useAppSelector((state) => state.newFeed);

  const fetchInitFrieds = async () => {
    setLoadingInitFriends(true);
    try {
      const url = `${RouteApi.getFriendUser}token=${token}`;
      const response = await RequestApi(url);
      if (response.status === "success") {
        dispatch(setInitFriends(response.friend_users.data));
        setLoadingInitFriends(false);
      }
    } catch (error) {
      setLoadingInitFriends(false);

      AppLog.show({
        message: `[fetchInitFrieds]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  useEffect(() => {
    if (friends.length === 0) {
      fetchInitFrieds();
    }
  }, []);

  const [containerHeight, setContainerHeight] = useState("h-[300px]");

  useEffect(() => {
    const updateHeight = () => {
      if (window.innerWidth <= 1440) {
        setContainerHeight("min-h-[50 px] ");
      } else {
        setContainerHeight("min-h-[170px] ");
      }
    };

    updateHeight();
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  return (
    <>
      <Dialog open={isDialogOpen}>
        <DialogContent isShowBtnXClose={false} className="max-w-full lg:max-w-[600px]  h-[calc(100vh-80px)] py-2 px-0 flex flex-col p-4 ">
          <DialogHeader>
            <DialogTitle className=" text-start">Share</DialogTitle>
            <DialogDescription className=" text-start">Manage your accounts to control who can interact with you.</DialogDescription>
            <div
              className="absolute flex items-center justify-center right-3 top-1 z-40 cursor-pointer rounded-full hover:bg-accent hover:text-accent-foreground w-[36px] h-[36px] p-2"
              onClick={() => setIsDialogOpen(false)}
            >
              <X />
            </div>
          </DialogHeader>

          <div className="flex flex-1 h-full flex-col space-y-2 ">
            <div className="w-full ">
              <div className="mt-2 gap-3 ">
                <div className="flex flex-col items-end justify-end  space-y-4 ">
                  <div className="flex flex-row items-start space-x-2 w-full pt-2">
                    <ImageUrlProfile user={Service.userAuth} style={{ width: 50, height: 50 }} className="rounded-full object-cover border shadow-md " isLinkProfile={true} />
                    <div className="flex flex-row justify-between items-center w-full">
                      <div className="flex flex-col">
                        <div className="flex items-center space-x-2">
                          <div className="text-lg font-bold ">{Service.userAuth?.name ?? ""}</div>

                          {post?.re_post_user?.is_verified === "Yes" && (
                            <img
                              src={profileVerified}
                              // src=""
                              alt=""
                              style={{ width: 18, height: 18 }}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="w-full">
                    <Textarea
                      value={textComment}
                      onKeyDown={onHandleKeyDown}
                      maxLength={100}
                      onChange={(e) => setTextComment(e.target.value)}
                      className={`border border-none ${containerHeight}   focus-visible:ring-0 focus-visible:ring-offset-0 w-full  px-0 py-0 rounded-none `}
                      placeholder="Write somthing here"
                    />
                  </div>
                  <Popover>
                    <PopoverTrigger asChild>
                      {/* <div className="flex w-8 h-8 rounded-full  bg-gray-200 text-center items-center justify-center"> */}
                      <Avatar className="w-8 h-8 cursor-pointer">
                        <AvatarFallback className="text-[30px]">
                          <FontAwesomeIcon
                            icon={faFaceSmileBeam}
                            className="text-gray-500 dark:text-gray-500 cursor-pointer size-5"
                            onClick={
                              () => ""
                              // setShowEmojiPicker((prev) => !prev)
                            }
                          />
                        </AvatarFallback>
                      </Avatar>
                    </PopoverTrigger>
                    <PopoverContent className="w-92">
                      <div
                        // ref={emojiPickerRef}
                        className="absolute bottom-[-400px] lg:left-[20px] left-[-350px] z-[100]"
                        spellCheck={false}
                      >
                        <EmojiPicker reactionsDefaultOpen={false} onEmojiClick={onEmojiClick} emojiStyle={EmojiStyle.FACEBOOK} searchDisabled={true} skinTonesDisabled={true} />
                      </div>
                    </PopoverContent>
                  </Popover>
                  <Button
                    onClick={() => {
                      submitSharePost();
                    }}
                    className=" mt-3 dark:text-white bg-blue-600 hover:bg-blue-700 px-5"
                  >
                    Share Now
                  </Button>
                </div>
                <SelectSeparator className=" bg-gray-700 my-4" />
              </div>
              <div className="w-full  ">
                <div>
                  <p className="text-md font-semibold mb-2">Share to</p>

                  <div className=" grid grid-cols-4">
                    {shareOptions.map((contact: any, index) => (
                      <a
                        href={contact.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        // to={contact.link}
                        key={index}
                        className="flex flex-col items-center"
                      >
                        <Avatar className="w-[50px] h-[50px] cursor-pointer relative z-[-1]">
                          <AvatarFallback className="text-[30px]">{contact.icon}</AvatarFallback>
                        </Avatar>
                        <p className="text-xs mt-1">{contact.name}</p>
                      </a>
                    ))}
                  </div>
                </div>
              </div>
              <div className="w-full mt-[30px]   ">
                {LoadinginitFriends ? (
                  <ShimmerFriends />
                ) : (
                  <>
                    <div className="flex flex-1 flex-col h-full">
                      <div className="flex justify-between items-center my-2">
                        <p className="text-md font-semibold">Send in Connector</p>
                      </div>

                      <div className="relative z-[1] mb-4" onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
                        {/* Previous Button */}
                        {showPrev && (
                          <button
                            onClick={() => scroll("left")}
                            className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white bg-opacity-100 p-2 rounded-full shadow-md hover:bg-opacity-100"
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                            </svg>
                          </button>
                        )}

                        {/* Story List */}
                        <div ref={containerRef} className={`flex overflow-x-auto space-x-2 pt-2 no-scrollbar  ${hovered ? "scrollbar-visible" : "scrollbar-custom "}`}>
                          {initFriends?.map((contact: any, index: any) => (
                            <div className="relative w-24 h-40 flex-shrink-0 cursor-pointer rounded-xl overflow-hidden">
                              <ImageUrlProfileStory user={contact} className="w-14 h-14 shrink-0" isLinkProfile={true} />
                              <div className="flex justify-center  h-[50px] w-[100px]">
                                <div className="flex">
                                  <p className="text-sm text-center font-medium overflow-hidden line-clamp-2 flex  justify-center">{contact.name}</p>
                                </div>
                              </div>
                              <div className="flex  justify-center">
                                <button
                                  onClick={() => submitSendMessage(index)}
                                  className={`px-5 py-1 text-white rounded-md  flex items-center justify-center w-[100px] text-sm font-semibold 
                                ${loadingButtonIndex === index ? "bg-red-500" : clickedButtons.includes(index) ? "bg-gray-500 cursor-not-allowed" : "bg-red-500"}
                              `}
                                  disabled={loadingButtonIndex === index || clickedButtons.includes(index)}
                                >
                                  {loadingButtonIndex === index ? <Loader className="animate-spin size-5" /> : "Send"}
                                </button>
                              </div>
                            </div>
                          ))}
                          <div className="flex justify-center mt-1">
                            <Avatar
                              onClick={() => {
                                setIsDailogSearchFriendsSend(true);
                              }}
                              className="w-[50px] h-[50px] cursor-pointer"
                            >
                              <AvatarFallback className="text-[30px]">
                                <Search />
                              </AvatarFallback>
                            </Avatar>
                          </div>
                        </div>

                        {/* Next Button */}
                        <button
                          onClick={() => scroll("right")}
                          className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white bg-opacity-100 p-2 rounded-full shadow-md hover:bg-opacity-100"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
      {isDailogSearchFriendsSend && (
        <DailogSearchFriendsSend
          clickedButtons={clickedButtons}
          loadingButtonIndex={loadingButtonIndex}
          submitSendMessage={submitSendMessage}
          isDailogSearchFriendsSend={isDailogSearchFriendsSend}
          setIsDailogSearchFriendsSend={setIsDailogSearchFriendsSend}
        />
      )}
    </>
  );
}

